import React from 'react';
import ReactComponentWrapper from '../ReactComponentWrapper';
import Translate from '../components/Translate';
import i18next from 'config/i18next';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.renderLanguageDropdown = this.renderLanguageDropdown.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        const languageKey = i18next.language.replace('_', '-');
        this.state = {
            showLanguageDropdown: false,
            languageSelection: languages.find((language) => language.locale.indexOf(languageKey) !== -1)
        };
    }

    /**
     * renderLanguageDropdown - occurs when the language dropdown is rendered
     *
     * @param  {object} event
     * @return {undefined}
     */
    renderLanguageDropdown(event) {
        event.preventDefault();
        const toggleLanguageDropdown = !this.state.showLanguageDropdown;
        this.setState({ showLanguageDropdown: toggleLanguageDropdown });
    }

    /**
     * changeLanguage - occurs when user selects a language
     *
     * @param  {string} languageKey a string containing the locale of the language selected
     * @return {undefined}
     */
    changeLanguage(languageKey) {
        const that = this;

        const i18nLanguageKey = languageKey.replace('-', '_');

        i18next.changeLanguage(i18nLanguageKey, () => {
            that.setState({
                languageSelection: languages.find((language) => language.locale === languageKey)
            });
        });
    }

    renderDropdown() {
        const isHidden = this.state.showLanguageDropdown ? { display: 'block' } : { display: 'none' };

        return (
            <ul
                id="country-selector-dropdown"
                style={isHidden}
                aria-labelledby="dLabel"
                className={'dropdown dropdown-menu pull-right'}
            >
                {languages.map((item) => (
                    <li key={item.locale} onClick={() => this.changeLanguage(item.locale)}>
                        <a
                            className={`flag-${item.locale} language-links`}
                            data-locale={item.locale}
                            href={`/${item.locale}/signin`}
                        >
                            {item.title}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        const { languageSelection } = this.state;

        return (
            <ReactComponentWrapper {...this.props}>
                <div className="header" id="global-header-wrapper">
                    <div className="container">
                        <div className="navigation">
                            <a className="logo pull-left" href="/en-US/" title="Connect - Powered by Garmin">
                                <Translate ns="main_container" content="main_header_garmin_connect_text" />
                            </a>
                            <ul className="nav nav-pills pull-left">
                                <li className="nav-home">
                                    <a href="/en-US/">
                                        <Translate ns="main_container" content="main_header_home_text" />
                                    </a>
                                </li>
                                <li className="nav-features">
                                    <a href="/en-US/features/">
                                        <Translate ns="main_container" content="main_header_features_text" />
                                    </a>
                                </li>
                                <li className="nav-started">
                                    <a href="/en-US/start/">
                                        <Translate ns="main_container" content="main_header_get_started_text" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="utility pull-right">
                            <ul className="nav nav-pills">
                                <li className="nav-signin-container">
                                    <a className="nav-signin" href="/en-US/signin">
                                        <Translate ns="main_container" content="main_header_sign_in_text" />
                                    </a>
                                </li>
                                <li className="nav-dash-container">
                                    <a className="nav-dashboard" href="/user-dashboard/check">
                                        <Translate ns="main_container" content="main_header_dashboard_text" />
                                    </a>
                                </li>
                                <li className="nav-help-container">
                                    <a className="nav-help" href="/en-US/help">
                                        <Translate ns="main_container" content="main_header_help_text" />
                                    </a>
                                </li>
                                <li
                                    id="api-locale-options"
                                    className="country-selector has-menu dropdown"
                                    onClick={this.renderLanguageDropdown}
                                >
                                    <a href="#country-selector-dropdown" className="dropdown-toggle flag-en-US">
                                        {languageSelection?.title || 'English'}
                                        <i className="icon-pointer-down" />
                                    </a>
                                    {this.renderDropdown()}
                                </li>
                                <li className="nav-signout-container">
                                    <a className="nav-signout" href="/auth/logout">
                                        <Translate ns="main_container" content="main_header_sign_out_text" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ReactComponentWrapper>
        );
    }
}

export default Header;

const languages = [
    {
        locale: 'ko-KR',
        title: '한국어'
    },
    {
        locale: 'th-TH',
        title: 'ไทย'
    },
    {
        locale: 'in-ID',
        title: 'Bahasa Indonesia'
    },
    {
        locale: 'ms-MY',
        title: 'Bahasa Melayu'
    },
    {
        locale: 'cs-CZ',
        title: 'Čeština'
    },
    {
        locale: 'da-DK',
        title: 'Dansk'
    },
    {
        locale: 'de-DE',
        title: 'Deutsch'
    },
    {
        locale: 'en-US',
        title: 'English'
    },
    {
        locale: 'es-ES',
        title: 'Español'
    },
    {
        locale: 'fr-FR',
        title: 'Français'
    },
    {
        locale: 'hr-HR',
        title: 'Hrvatski'
    },
    {
        locale: 'it-IT',
        title: 'Italiano'
    },
    {
        locale: 'hu-HU',
        title: 'Magyar'
    },
    {
        locale: 'nl-NL',
        title: 'Nederlands'
    },
    {
        locale: 'nb-NO',
        title: 'Norsk'
    },
    {
        locale: 'pl-PL',
        title: 'Polski'
    },
    {
        locale: 'pt-BR',
        title: 'Português (Brasil)'
    },
    {
        locale: 'pt-PT',
        title: 'Português (Portugal)'
    },
    {
        locale: 'sk-SK',
        title: 'Slovenčina'
    },
    {
        locale: 'sl-SI',
        title: 'Slovenščina'
    },
    {
        locale: 'fi-FI',
        title: 'Suomi'
    },
    {
        locale: 'sv-SE',
        title: 'Svenska'
    },
    {
        locale: 'iw-IL',
        title: 'עברית'
    },
    {
        locale: 'el-GR',
        title: 'Ελληνικά'
    },
    {
        locale: 'ru-RU',
        title: 'Русский'
    },
    {
        locale: 'ja-JP',
        title: '日本語'
    },
    {
        locale: 'zh-CN',
        title: '简体中文'
    },
    {
        locale: 'zh-TW',
        title: '繁體中文'
    }
];
